import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Upload, CheckCircle2 } from "lucide-react";

export const SponsorLogoUpload = ({ token }) => {
  const [info, setInfo] = useState(null);
  const [website, setWebsite] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/sponsorship/logo/${token}`).then(({ data }) => { setInfo(data); setWebsite(data.website || ""); })
      .catch(() => setInfo({ error: true }));
  }, [token]);

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    setBusy(true);
    try {
      const { data } = await api.post(`/sponsorship/logo/${token}`, fd, {
        params: website ? { website } : {}, headers: { "Content-Type": "multipart/form-data" } });
      setInfo(data);
      toast.success("Your logo is live on CBR Prospects!");
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail) || "Upload failed"); }
    finally { setBusy(false); }
  };

  if (!info) return null;
  if (info.error) return <p data-testid="sponsor-logo-invalid" className="text-sm text-[#E63946] mt-4">This logo link isn't valid. Please contact CBR.</p>;
  return (
    <div data-testid="sponsor-logo-upload" className="mt-8 border border-slate-200 rounded-sm p-6 text-left">
      <div className="font-display text-xl uppercase tracking-tight text-[#0A192F]">{info.logo_url ? "Your logo is live" : "Upload your logo"}</div>
      <p className="text-xs text-slate-500 mt-1">PNG with a transparent background works best (under 5MB). It appears on the site right away{info.ends_at ? ` and stays up until ${info.ends_at.slice(0, 10)}` : " for one year"}.</p>
      {info.logo_url && (
        <div className="mt-4 flex items-center gap-2 text-emerald-700 text-sm">
          <CheckCircle2 className="w-4 h-4" />
          <img data-testid="sponsor-logo-preview" src={info.logo_url} alt={`${info.company} logo`} className="h-16 max-w-[200px] object-contain bg-slate-50 border border-slate-200 rounded-sm p-2" />
        </div>
      )}
      <input data-testid="sponsor-logo-website" placeholder="Your website (logo will link here)" value={website} onChange={(e) => setWebsite(e.target.value)}
        className="mt-4 w-full px-3 py-2.5 border border-slate-300 rounded-sm text-sm" />
      <label className={`mt-3 inline-flex items-center gap-2 cursor-pointer bg-[#E63946] hover:bg-[#D90429] text-white px-5 py-3 text-sm font-semibold uppercase tracking-wider rounded-sm ${busy ? "opacity-60 pointer-events-none" : ""}`}>
        <Upload className="w-4 h-4" /> {busy ? "Uploading…" : info.logo_url ? "Replace Logo" : "Upload Logo"}
        <input data-testid="sponsor-logo-file" type="file" accept="image/*" className="hidden" onChange={(e) => upload(e.target.files?.[0])} />
      </label>
    </div>
  );
};
